import { Component, ElementRef, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TicketService } from './ticket.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { TicketModel } from './ticket.model';
import { ContactService } from '../../contact/contact/contact.service';
import { ContactBankAccountService } from '../../contact/contactbankaccounts/contactbankaccount.service';
import { TicketListComponent } from './ticket-list.component';

@Component({
    selector: 'convfact-ticketrectification',
    templateUrl: './ticket-dialog-rectification.component.html',
    styleUrls: ['./ticket-dialog-rectification.component.css'],
    standalone: false
})

export class TicketDialogRectificationComponent {

    uid: string = this.data.uid;
    ticket: TicketModel = this.data.ticket;
    errors: string[] = [];
    error = false;
    ready = false;

    constructor(
        public dialogRef: MatDialogRef<TicketListComponent>,
        public ticketService: TicketService,
        public contactService: ContactService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public contactBankAccountService: ContactBankAccountService
    ) { }

    rectification(): void {
        this.ready = true;
        this.ticketService.loadData(this.uid).then(ticket => {
            this.ticket = ticket;
            this.ticket.rectifying = true;
            this.ticketService.editData(this.ticket.uid, this.ticket).then(
                ticket => {
                    this.ticket = ticket;
                    this.closeDialog();
                    this.ready = false;
                }
            )
        })
    }

    closeDialog() {
        this.dialogRef.close();
    }

}